module.exports = __webpack_public_path__ + "img/V0.122ed092.png";